import $ from 'jquery';

$(() => {
    let $collapseInEu = $('.collapse-in-eu').collapse({ toggle: false });
    let $collapseOutsideEu = $('.collapse-outside-eu').collapse({ toggle: false });

    $('[name=established_outside_eu]').on('change', (e) => {
        $collapseInEu.collapse(e.currentTarget.value === '0' ? 'show' : 'hide');
        $collapseOutsideEu.collapse(e.currentTarget.value === '1' ? 'show' : 'hide');
    });

    let $company = $('#company').collapse({ parent: '#establishment', toggle: false });
    let $branch = $('#branch').collapse({ parent: '#establishment', toggle: false });

    $('[name=establishment]').on('change', (e) => {
        $company.collapse(e.target.value == 'company' ? 'show' : 'hide');
        $branch.collapse(e.target.value == 'branch' ? 'show' : 'hide');
    });
});
